// 权限管理路由
const general: any = [
    {
        path: 'operate/operator',
        name: 'operator_list',
        meta: {
            pathTitle: 'channel_manage',
            title: '运营列表'
        },
        component: () => import('@/views/operate/operator.vue')
    },
    {
        path: 'operate/department',
        name: 'department',
        meta: {
            pathTitle: 'operator_list',
            title: '组织架构'
        },
        component: () => import('@/views/operate/department.vue')
    },
    {
        path: 'operate/operateUser',
        name: 'operator_users',
        meta: {
            pathTitle: 'channel_manage',
            title: '用户列表'
        },
        component: () => import('@/views/operate/user.vue')
    },
    {
        path: 'operate/role',
        name: 'operator_roles',
        meta: {
            pathTitle: 'channel_manage',
            title: '角色列表'
        },
        component: () => import('@/views/operate/role.vue')
    },
]
export default general
